import type { ComponentProps, ReactElement, ReactNode, Ref } from 'react';
import * as React from 'react';
import type { Except } from 'type-fest';
import type { LinkImplementationRequiredProps, LinkProps } from '../Link';
import { Link } from '../Link';
import { ButtonContent } from './ButtonContent';
import type { BaseButtonProps, ButtonType } from './baseTypes';
import { getClassNames } from './getClassNames';

export interface BaseLinkButtonProps extends BaseButtonProps<'a'> {
  type?: ButtonType;
  children: NonNullable<ReactNode>;
}

export interface BaseHrefLinkButtonProps extends BaseLinkButtonProps {
  href: string;
  to?: never;
}
export type BaseToLinkButtonProps = BaseLinkButtonProps &
  LinkProps<LinkImplementationRequiredProps & { to: any }> & {
    href?: never;
  };

export type LinkHrefButtonProps = BaseHrefLinkButtonProps & Except<ComponentProps<'a'>, 'ref'>;
export type LinkToButtonProps = BaseToLinkButtonProps & Except<ComponentProps<'a'>, 'ref'>;

export type LinkButtonProps = LinkHrefButtonProps | LinkToButtonProps;

const onClickPreventDefault = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
  e.preventDefault();
};

/** @deprecated use ExternalLink from kitt-universal instead */
export const LinkButton = React.forwardRef(
  (
    {
      children,
      type,
      disabled,
      href,
      to,
      icon,
      iconPosition = 'left',
      stretch,
      large,
      xLarge,
      target,
      onClick,
      className,
      variant = 'default',
      ...props
    }: LinkButtonProps,
    ref: Ref<HTMLAnchorElement>,
  ): ReactElement => {
    return (
      <Link
        ref={ref}
        className={
          type === 'link'
            ? undefined
            : getClassNames(children, !!icon, iconPosition, large, xLarge, stretch, type, disabled, className, variant)
        }
        disabled={disabled}
        href={href}
        to={to}
        target={target}
        rel={target ? 'noopener noreferrer' : undefined}
        onClick={disabled ? onClickPreventDefault : onClick}
        {...(props as LinkButtonProps)}
      >
        {type === 'link' ? (
          children
        ) : (
          <ButtonContent icon={icon} iconPosition={iconPosition}>
            {children}
          </ButtonContent>
        )}
      </Link>
    );
  },
);
